import Seo from "@/lib/Seo";
import InquiryForm from "@/components/InquiryForm";
import { FadeUp } from "@/lib/motion";
import { SITE } from "@/data/content";
import Breadcrumbs from "@/components/Breadcrumbs";

export default function Contact() {
  return (
    <div className="pt-[72px]">
      <Seo
        title="Contact Marble & Veil — Southern California Weddings"
        description="Say hello and tell us about your celebration. We follow up using your preferred contact method."
        path="/contact"
      />
      <section className="mx-auto max-w-4xl px-5 py-16 sm:px-8 lg:py-24">
        <Breadcrumbs trail={[["Home", "/"], ["Contact"]]} />
        <FadeUp>
          <h1 className="mt-6 font-display text-5xl leading-[1.05] text-ink sm:text-6xl">Contact</h1>
          <p className="mt-5 max-w-xl leading-relaxed text-smoke">
            The form below is the fastest way to reach us. Prefer email? Write to{" "}
            <a href={`mailto:${SITE.email}`} className="border-b border-olive text-olive" data-testid="contact-email-link">
              {SITE.email}
            </a>{" "}
            or call{" "}
            <a href={SITE.phoneHref} className="border-b border-olive text-olive" data-testid="contact-phone-link">
              {SITE.phone}
            </a>
            .
          </p>
          <p className="mt-3 text-sm text-smoke" data-testid="contact-address">
            <span className="mv-label mb-1 inline-block">Our studio</span>
            <br />
            {SITE.address}
          </p>
        </FadeUp>
        <div className="mt-12">
          <InquiryForm mode="contact" />
        </div>
      </section>
    </div>
  );
}
